<template>
  <div>
    <div class="fg-notification">
      <div class="fg-wrap">
        <div class="fg-title">
          <div class="txt">
            已选择赴馆日期
          </div>
          <base-popover-with-close
            ref="basePopover"
            position="top"
            width="300px"
            trigger="hover"
            :show-close-icon="false"
            :content="getContent"
          >
            <img class="icon-tooltip" src="https://o.666visa.cn/static/ssqpeer/common/icon_tooltip.png" alt="">
          </base-popover-with-close>
        </div>

        <div class="fg-items">
          <div class="fg-item nameAndTime" v-for="item in applicantGrouped" :key="item.order_applicant_id"
               v-if="[1,2,9,8,17].indexOf(item.applicant_status) > -1 && item.interview_status == 0">
            <div class="fg-item-title">
              <div class="fg-item-title-icon"></div>
              <div class="fg-item-title-detail">{{item.displayName}}</div>
            </div>
            <div class="fg-item-content" v-if="item.embassy_district_name">赴馆城市：{{item.embassy_district_name}}</div>
            <div class="fg-item-content">
              {{item.date_choice == 0 ? "赴馆日期：指定日期 " + item.preferred_date_str : item.date_choice == 2 ? "赴馆日期：近30天内均无法前往（" + item.other_date + "）" : "赴馆日期：" + choiceMap[item.date_choice] }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dateUtils from '../../libs/date-util';
import BasePopoverWithClose from '../../components/common/popover/base-popover-with-close.vue';
import orderingService from '../../services/ordering-service';

const choiceMap = {
  1: '近30天内任何时间都方便',
  2: '近30天内均无法前往',
  3: '预计出行日期之前均方便',
  4: '30天后均方便',
};

const periodMap = {
  0: '整天',
  1: '上午',
  2: '下午',
};

export default {
  props: {
    order: {
      type: Object,
      default: {},
    },
  },
  components: {
    BasePopoverWithClose,
  },
  data() {
    return {
      choiceMap,
      DM: {},
      applicantGrouped: [],
      period: {
        0: '整天',
        1: '上午',
        2: '下午',
      },
      earlistDateData: null,
    };
  },
  computed: {
    // 获取每次修改赴馆时间价格
    getUpdateDatePrice() {
      return this.earlistDateData
        ? this.earlistDateData.interview_change_fee / 100
        : 0;
    },
  },
  created() {
    // 处理数据
    this.DM = this.order;
    const applicant = this.DM.applicant;
    const applicantGroupedMap = {};

    // 判断interview_together

    applicant &&
      applicant.forEach((applicantVal) => {
        if ([1, 2, 9, 8, 17].indexOf(applicantVal.applicant_status) > -1) {
          let key = applicantVal.order_applicant_id;
          if (this.DM.interview_together === 1) {
            // 取第一条
            key = 'only';
          }
          applicantGroupedMap[key] = (applicantGroupedMap[key] || []).concat(
            applicantVal,
          );
        }
      });
    this.applicantGrouped = Object.keys(applicantGroupedMap).map((joinKey) => {
      // 取第1个
      const applicantList = applicantGroupedMap[joinKey][0];
      // 处理名字
      let displayName = '';
      if (applicantGroupedMap[joinKey].length === 1) {
        displayName = applicantList.applicant_name;
      } else if (applicantGroupedMap[joinKey].length > 1) {
        applicantGroupedMap[joinKey].forEach((val) => {
          displayName += `${val.applicant_name}、`;
        });
        displayName = displayName.slice(0, -1);
      }

      // 判断是否修改过赴馆时间
      const date_choice = applicantList.interview.date_choice;
      const preferred_date = applicantList.interview.preferred_date;
      const other_date = applicantList.interview.other_date;
      const applicant_status = applicantList.applicant_status;
      const interview_status = applicantList.interview_status;
      let preferred_date_str = '';
      if (date_choice === 0) {
        // 手动选择修改
        const preferred_date_change = preferred_date.map(
          ({ date, period }) =>
            `${dateUtils.formatDateWithzeroWithWeek(date)} ${periodMap[period]}`,
        );
        preferred_date_str = preferred_date_change.join('、');
      }

      const embassy_district_name = applicantList.interview.embassy_district_name;


      return {
        displayName,
        date_choice,
        other_date,
        preferred_date_str,
        applicant_status,
        interview_status,
        embassy_district_name,
      };
    });
  },
  async mounted() {
    await this.getEarlistDateData();
  },
  methods: {
    getEarlistDateData() {
      return orderingService.getEarlistDateData(this.DM.user_order_id).then((data) => {
        this.earlistDateData = data;
      }).catch((e) => {
        if (e) console.log(e);
      });
    },
    
    getContent() {
      const interviewNotice = this.earlistDateData && this.earlistDateData.interview_notice || '';
      return `
    <div class="cue-item">您选择的赴馆时间签证专家会为您优先预约，若无法预约，签证专家将联系您重新确认。</div>
    <div class="cue-item">预约成功后如需修改赴馆时间，需补缴 <span class="mark">${this.getUpdateDatePrice}元/人/次</span>，并重新预约。
    </div>${interviewNotice ? `<div>${interviewNotice}</div>` : ''}
  `;
    },
  },
};
</script>

<style lang="less" scoped>
.fg-notification {
  width: 920px;
  margin-top: 14px;
  margin-bottom: 15px;
  color: #444;
  .fg-wrap {
    background-color: #fff;
    .fg-title {
      padding: 18px 20px 2px 20px;
      display: flex;
      flex: 1;
      align-items: center;
      gap: 8px;
      .txt {
        font-size: 16px;
        font-weight: 600;
        color: #333;
      }
      .icon-tooltip{
        display: block;
        width: 18px;
        height: 18px;
        cursor: pointer;
      }
      .small {
        font-size: 14px;
        color: #777;
        margin-left: 8px;
      }
    }

    .fg-items {
      padding: 0 46px 0 68px;
    }

    .fg-item {
      position: relative;
      padding: 20px 10px 20px 0px;
      font-size: 16px;
      border-bottom: 1px solid #f4f4f4;
      .fg-item-title {
        display: flex;
        flex: 1;
        align-items: center;
        .fg-item-title-icon {
          width: 16px;
          height: 16px;
          margin-left: -26px;
          margin-right: 10px;
          background-size: 16px 16px !important;
        }
        .fg-item-title-detail {
          color: #333;
        }
      }
      .fg-item-content {
        margin-top: 16px;
        font-size: 14px;
        color: #777;
      }
      .fg-item-offline {
        position: relative;
        color: #ff5a60;
        margin-top: 18px;
        margin-left: -26px;
        font-size: 12px;
        &:before {
          content: url(../../assets/imgs/fg_offline_notice.png);
          position: absolute;
          width: 14px;
          height: 14px;
          left: -24px;
          top: -1px;
        }
      }
    }
    .nameAndTime {
      .fg-item-title-icon {
        background: url(../../assets/imgs/fg_date_white.png);
      }
      .fg-item-content {
        color: #777;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/order-detail/order-fg-date.vue